import Api from "../axios";

export default async function getShortDays(employeeId) {
  return await Api.get(`/short_days?employee_id=${employeeId}`);
}